import { Grid, Typography } from '@material-ui/core'
import { FC } from 'react'
import customEmailIcon from '../../../images/customEmailIcon.svg'
import { MuiClasses } from '../../../types'

interface NavBarPhoneNumberProps {
  isAuthenticated: boolean | undefined
  smallScreen: boolean
  isTinyScreen: boolean
  classes: MuiClasses
}

const NavBarPhoneNumber: FC<NavBarPhoneNumberProps> = ({
  isAuthenticated,
  smallScreen,
  isTinyScreen,
  classes
}) => (
  //   <Grid
  //   item
  //   {...((isAuthenticated || smallScreen) && {
  //     className: classes.phoneNumberDiv
  //   })}
  // >
  <Grid item className={classes.phoneNumberDiv}>
    <span style={{ color: '#fff' }}>
      <a
        style={{ color: 'inherit', textDecoration: 'none' }}
        href='mailto:info@fiksuvuokraus.fi'
      >
        <Grid container direction='row'>
          <Grid item>
            <img className={classes.image} src={customEmailIcon} />
          </Grid>
          <Grid item className={classes.phoneNumberTextDiv}>
            <Typography {...(isTinyScreen && { variant: 'body2' })}>
              {'info@fiksuvuokraus.fi'}
            </Typography>
          </Grid>
        </Grid>
      </a>
    </span>
  </Grid>
)

export default NavBarPhoneNumber
